import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;

//import fullpage from 'fullpage.js';

require('foundation-sites');



// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';
import './lib/scrolloverflow.min';

import './lib/fullpage.scrollOverflowReset.min';

import fullpage from './lib/fullpage.extensions.min';

import { TimelineMax, CSSPlugin, ScrollToPlugin, Draggable } from "gsap/all"; 

$(document).foundation();


$(document).ready(function($) {



         var base_url = window.location.origin;
                  $.ajax({
                        
                        url : base_url + "/wp-content/themes/twentynineteen/link-json.php",
                        //url: '../../link-json.php',
                        async: false,
                        dataType: 'json',
                        success: function(data) {

                             /// console.log(data)
                             $('.section03grid').empty();
                              $.each(data, function (index, value) {

                                    var $cell = '<div class="link">';
                                    $cell += '<div class="link-picture"><a href="'+value['link']+'" target="_blank"><img src="'+value['url']+'"></a></div>';
                                    $cell += '<div class="link-title"><a href="'+value['link']+'" target="blank">"'+value['title']+'"</a></div>';
                                    $cell += '</div>';
                                    $('.section03grid').append($cell);
                                    });
                    }
              });





new fullpage('#fullpage', {
    //options here
   // anchors: ['landingPage', 'section1', 'section2', 'section3'],
    licenseKey: '29BB16A0-F5744CC3-A9D16916-36641040',
    css3:false,
    //normalScrollElements: '#section3',
  // scrollOverflow: true,
   // scrollOverflow:true,
   // scrollOverflowReset: true,
   // scrollOverflowResetKey: 'c2t5YXJyb3cuZGF2aWRlY2F0Lml0X2x4NGMyTnliMnhzVDNabGNtWnNiM2RTWlhObGRBPT1XOUc=',
    //, autoScrolling:true,
   // scrollHorizontally: true
    afterLoad: function(origin, destination, direction){
              var loadedSection = this;
            //   console.log(loadedSection);
            //   console.log(destination.index);
            //   console.log(direction);
              // Da qui triggero tutte le animazioni in entrata nelle sections e nelle slides
              if (destination.index == 0){
                  // console.log(destination.index);
                      if (direction =='up'){
                          
                        //     console.log("il video non parte");
                            allowScroll(true);
                            $('.section0Layer').css( "opacity", 1 ); 
                            $('#myVideo').trigger('play');
                            
                      }else{
                           allowScroll(false);


                      }
              }

               if (destination.index == 1){
                  // console.log(destination.index);
                      if (direction =='up'){
                          
                            
                            allowScroll(true);
                            $('.section0Layer').css( "opacity", 1 ); 
                           
                            
                      }else{
                        
                           allowScroll(false);
                            $('#myVideo').trigger('pause');

     //animazione
       var section2TL = new TimelineMax();
      
       section2TL
       //.fromTo( $('.primo'), 1, {css:{ backgroundPosition:'50% 100vh'}}, {css:{ backgroundPosition:'50% 0vh'}})
        // .fromTo( $('.primo'), 0.5, {css:{  opacity:0}}, {css:{ opacity:1}})
        .fromTo( $('.primo p'), 0.5, {css:{ opacity:0}}, {css:{ opacity:1}})
         //.fromTo( $('.secondo'), 1, {css:{ backgroundPosition:'50% -100vh'}}, {css:{ backgroundPosition:'50% 0vh'}})
           // .fromTo( $('.secondo'), 0.5, {css:{ opacity:0}}, {css:{ opacity:1}})
           .fromTo( $('.secondo p'), 0.5, {css:{ opacity:0}}, {css:{ opacity:1}})
       // .fromTo( $('.terzo'), 1, {css:{ opacity:0}}, {css:{ opacity:1}})
         //.fromTo( $('.terzo'), 0.5, {css:{ opacity:0}}, {css:{ opacity:1}})
          .fromTo( $('.terzo p'), 0.5, {css:{ opacity:0}}, {css:{ opacity:1}})

          //,onComplete: function(){ allowScroll(true);}
      


    
                      }
              } 
              if (destination.index == 2){
                  if (direction =='up'){
                        //   console.log(destination.index);
                            
                        allowScroll(false);
                        //$('.section0Layer').css( "opacity", 1 ); 
                  
                        
                  }

           

          } 

   }


});


$(".toggleAudio").click( function (){

$("#myVideo").prop('muted', !$("video").prop('muted'));

 });

 //$('#myVideo').trigger('play');
    
    $('h1.avanti').hide();
    setTimeout(function(){
        $('h1.avanti').fadeIn("slow");; 
    }, 5000);
});




$(window).on('load', function() {
   /*  console.log('load');
    $('.preloader-wrapper').fadeOut();
    $('body').removeClass('preloader-site'); */

setTimeout(function() {
    $('#myVideo').trigger('play');
}, 0);
   
});

function allowScroll(attiva){

        if (attiva){
              fullpage_api.setAllowScrolling(true);
              fullpage_api.setKeyboardScrolling(true);
              /* var sectionScroll_tl = new TimelineMax();
              sectionScroll_tl.to(".sectionScroll", 2, {opacity: 1}); */
        }else{
              fullpage_api.setAllowScrolling(false, 'down');
              fullpage_api.setKeyboardScrolling(false, 'down');
             /*  var sectionScroll_tl = new TimelineMax();
              sectionScroll_tl.to(".sectionScroll", 0, {opacity: 0}); */
        }


}



/////////////////////////////////////////////////////////////
// SCript per Section0
/////////////////////////////////////////////////////////////
// $('#myVideo').on('ended',function(){
//$('#videosrc')[0].load();
 $("#myVideo").on("timeupdate",
    function(event){

      if (this.currentTime > 10 && this.currentTime < 11){


      
   // Attivo lo scrolling
    
    allowScroll(true);

        //prima timeline: logo Eni, titolo e caption
       


 $('.section0layer').css('opacity', '1');

        

       // $('#unmuteButton').fadeTo( "slow", 0 );  

        $('.section0layer').on('click', function () {

        //fullpage_api.moveTo(2);
         location.href = '/home-page';
      



        });
      }
      
});


$('.to-third-section').on('click', function () {
      fullpage_api.moveTo(3);

      allowScroll(false);


//      // http://loc.sky/wp-admin/admin-ajax.php&action=myaction&id=2
//       $.getJSON('/wp-admin/admin-ajax.php',{
//       action: 'myaction',
//       id: 2
//             }, 
      
//       function(json){
//             console.log('pippo');
//       });

});


$('.link').
mouseover( function ( event ) {
   var target = $( event.target );

  console.log("hover link 1");
   target.css('backgroundColor', '#ffd520'); 

})
 .mouseout(function(  event ) {
     var target = $( event.target );
  target.css('backgroundColor', '#333333'); 
  });
;
;


$('.link-cell-2')
.mouseover( function () {
  console.log("hover link 1");
     $('.link-cell-2').css('backgroundColor', '#ffd520'); 

})
  .mouseout(function() {
   $('.link-cell-2').css('backgroundColor', '#333333'); 
  });
;

$('.link-cell-3')
.mouseover( function () {
  console.log("hover link 1");
     $('.link-cell-3').css('backgroundColor', '#ffd520'); 

})
 .mouseout(function() {
   $('.link-cell-3').css('backgroundColor', '#333333'); 
  });
;
;









